export default "__VITE_ASSET__C4$k7qzn__"